import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { TriggerBalanceCheckRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { TriggerBalanceCheckResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const triggerBalanceCheck = (request: TriggerBalanceCheckRequest, options?: CashRequestOptions) =>
  post<TriggerBalanceCheckRequest, TriggerBalanceCheckResponse>('/2.0/cash/trigger-balance-check', request, {
    ...options,
    rejectOnError: true,
  })
